export const IMAGE_EXTENSION = ".jpg"
export const SOFA_COLOUR_CHIP_PREFIX = "SofaSwatchView"
export const COLOUR_CHIP_PREFIX = "AltItemSwatch/21x21"

export const SHOW_INITIAL_COLOURCHIPS = 18
export const COLOURCHIP_GREY_PLACEHOLDER_URL =
    "/Common/Items/Default/Default/ItemImages/AltItemSwatch/21x21/greySquarePlaceholder.jpg"
export const PRODUCT_IMAGE_GREY_PLACEHOLDER_URL =
    "/Common/Items/Default/Default/ItemImages/Search/224x336/greyPlaceholder.jpg?X56"
export const FIT_ICON_PLACEHOLDER_URL = "/images/shared/transparent-image.png"
export const LAZY_SIZES_CLASSNAME = "lazyload"
export const SWIPER_LAZYLOAD_CLASSNAME = "swiper-lazy"
export const COLOURCHIP_UNEXPANDED_HEIGHT = 48
export const FAV_TIMER_LENGTH = 1000
export const MAX_LIMIT_FAVOURITES_FALLBACK = 150
export const LANGUAGE_HEADER = "x-next-language"
export const LANG_EN = "en"
export const DEPARTMENT_MENSWEAR = "menswear"
export const DEPARTMENT_HOMEWARE = "homeware"
export const GTM_PRODUCT_IMPRESSIONS_EVENT = "ee-productImpression"
export const GTM_PRODUCT_CLICK_EVENT = "ee-productClick"
export const FAV_ADD = "FAV_ADD"
export const FAV_REMOVE = "FAV_REMOVE"
export const FAV_ERROR_LIMIT_EXCEEDED = "MaximumLimitExceeded"
export const FAV_CATEGORY_EXCLUSION = ["Flowers", "Plants"]
export const WHEN_TO_LOAD_ADDITIONAL_COLOURCHIPS = 5
export const CLEARANCE_SASH_IMAGE_NAME = "CLEARANCE"
export const SALE_SASH_IMAGE_NAME = "SALE_CORNER_LEFT"
export const SASH_IMAGE_EXTENSION = ".png"

export const SITE_URL_HEADER = "x-next-siteurl"

export enum LowercaseFits {
    tall = "tall",
    petite = "petite",
    regular = "regular",
}

export enum Fits {
    Tall = "Tall",
    Petite = "Petite",
    Regular = "Regular",
}

export const FitsIcons = Object.freeze({
    Tall: "next_fit-tall.svg",
    Petite: "next_fit-petite.svg",
})

export enum SaleSashPosition {
    TL = "TL",
    TR = "TR",
    BL = "BL",
    BR = "BR",
}

export const BundleType = "bundle" as const
export const SuitType = "suit" as const
export const SofaType = "sofa" as const
export const ProductType = "product" as const
export const SaleUrl = "sale" as const
export const ClearanceUrl = "clearance" as const
export const BASELINE_PRODUCT_ID = "000000" as const

export type SummaryType = typeof SuitType | typeof ProductType | typeof SofaType | typeof BundleType

export const PRODUCT_SUMMARY_ID = "plp-product-summary-entrypoint"
export const PLP_ENTRYPOINT = "next-plp-entrypoint"
export const PRODUCT_SUMMARY_TILE_ID = "plp-product-summary-tile"
export const PRODUCT_SUMMARY_CACHE_TAG = "productsummaryui"
export const CACHE_HEADER_LAST_MODIFIED = "last-modified"
export const CACHE_HEADER_CACHE_TAGS = "edge-cache-tag"
export const LTR = "ltr"
export const PLP_DEFAULT_TITLE_CONTAINER = "plp-results-title-container"

export const GTM_FAVOURITES = "favourites"
export const GTM_ADD_FAVOURITES = "addFavourites"
export const GTM_REMOVE_FAVOURITES = "removeFromFavourites"
export const GTM_ERROR_ADD_FAVOURITES = "errorAddFromFavourites"
export const GTM_ERROR_REMOVE_FAVOURITES = "errorRemoveFromFavourites"

export const MADE_TO_MEASURE = "madeToMeasure"
export const PERSONALISED = "personalised"
export const M2M = "M2M"
export const HOMEWARE = "homeware"

export const AXE_CONFIGURATION = Object.freeze({
    rules: [
        {
            id: "landmark-one-main",
            enabled: false,
        },
        {
            id: "document-title",
            enabled: false,
        },
        {
            id: "html-has-lang",
            enabled: false,
        },
        {
            id: "page-has-heading-one",
            enabled: false,
        },
        {
            id: "region",
            enabled: false,
        },
    ],
})

export const DEV_ESI_HEADER = "test-with-local-esi"

export const DEFAULT_TEST_PRODUCT_ITEM_NUMBER = "530205"
export const DEFAULT_TEST_SOFA_ITEM_NUMBER = "D55556"

export const DEFAULT_COLOURCHIPS_SLICE = 3
export const XSMALL_SCREEN_COLOURCHIPS_SLICE = 3
export const SMALL_SCREEN_COLOURCHIPS_SLICE = 4
export const MEDIUM_SCREEN_FIVE_COLOURCHIPS_SLICE = 5
export const MEDIUM_SCREEN_COLOURCHIPS_SLICE = 6
export const LARGE_SCREEN_COLOURCHIPS_SLICE = 7
export const XL_SCREEN_COLOURCHIPS_SLICE = 8

export const AGGREGATORQUERYTYPES = (version = "v1") => ({
    product: `GetProductSummaryByItemNumber_${version.toUpperCase()}`,
    bundle: `GetSummaryByCompositeItemNumbers_${version.toUpperCase()}`,
    suit: `GetSuitSummaryByCompositeItemNumber_${version.toUpperCase()}`,
    sofa: `GetSofaByItemNumber_${version.toUpperCase()}`,
    clearance: `GetItemByItemNumber_${version.toUpperCase()}`,
    sale: `GetItemByItemNumber_${version.toUpperCase()}`,
})

export const V1 = "v1"
export const V2 = "v2"

export const IN_STOCK = "InStock"
export const SOLD_OUT = "SoldOut"
export const CLEARANCE = "C"
export const SALE = "S"
export const TRY_AGAIN = "TRY AGAIN"
export const ADD_TO_BAG_ERROR_MESSAGE = "Unable to add -productTitle- to your bag. Please try again."
export const ADD_TO_BAG_BTN = "Add to Bag"
export const OUT_OF_STOCK = "Out of Stock"
export const LOADING = "Loading..."
export const CHECKOUT = "Checkout"
export const VIEW_BAG = "View Bag"
export const SALE_PRICE = "Sale Price"
export const SIZE = "Size"
export const ITEM_ADDED_TO_BAG = "Item Added to Bag"
export const CHECKOUT_URL = "secure/checkout/transfer/checkoutcta"
export const VIEW_BAG_URL = "shoppingbag"
export const STOCK_STATUS = Object.freeze({
    inStock: "instock",
    lowStock: "lowstock",
    delayed: "delayed",
    soldOut: "soldout",
    itemUnavailable: "itemunavailable",
})
export const ECONNABORTED = "ECONNABORTED"
export const LIVE = "live"
export const PRODUCT_SUMMARY = "product-summary"
export const AGGREGATOR_ENDPOINT = "aggregator"
